module.exports = __webpack_public_path__ + "img/logo.6956b31d.png";